import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { Contact } from '../../../models/contact';

import { ContactService } from '../../../services/contacts/contact.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-contact-index',
  templateUrl: './contact-index.component.html',
  styleUrls: ['./contact-index.component.scss'],
})
export class ContactIndexComponent implements AfterViewInit, OnInit {
  /**
   * Bulk edit options
   * @type {any}
   */
  bulkEditOptions: any = {
    newsletter_mailinglists: [],
    users: [],
  };

  /**
   * Indicates if bulk edit options are loaded
   * @type {boolean}
   */
  bulkEditOptionsLoaded: boolean = false;

  /**
   * Bulk edit request params
   * @type {any}
   */
  bulkEditParams: any = {
    add_to_mailing_list: '1',
    append_notes: '1',
    append_tags: '1',
    contacts_bulk_edit: true,
    contacts_bulk_edit_selection: 'user_select',
  };

  /**
   * Contact search results for current page
   * @type {Array<Contact>}
   */
  contacts: Array<Contact> = [];

  /**
   * Count of total contacts of search result
   * @type {number}
   */
  count: number = 0;

  /**
   * Search options for sidebar
   * @type {any}
   */
  searchOptions: any = {
    matter_types: [],
    matter_user_types: [],
    matter_users: [],
    per_page: 20,
    role_types: [],
  };

  /**
   * Search params for search request
   * @type {any}
   */
  searchParams: any = {
    matter_type_id: [],
    matter_types: [],
    page: 1,
    per_page: 20,
    role_type_ids: [],
    role_types: [],
    search: true,
    matter_user_type_ids: [],
    matter_user_types: [],
  };

  /**
   * Selected matter type to add to selection
   * @type {any}
   */
  selectedMatterType: any;

  /**
   * Selected matter user type to add to selection
   * @type {any}
   */
  selectedMatterUserType: any;

  /**
   * Selected role type to add to selection
   * @type {any}
   */
  selectedRoleType: any;

  /**
   * Indicates if search request is being proccessed
   * @type {boolean}
   */
  searching: boolean = false;

  /**
   * Indicates if bulk edit form is to be shown
   * @type {boolean}
   */
  showBulkEdit: boolean = false;

  /**
   * Indicates if sidebar is to be maximized
   * @type {boolean}
   */
  sidebarMaximized: boolean = false;

  /**
   * Indicates if sidebar is to be shown for smaller width screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  /**
   * Indicates if bulk edit request is being  processed
   * @type {boolean}
   */
  submittingBulkEdit: boolean = false;

  /**
   * Constructor
   * @param {ContactService} private contactService Service to access contacts controller
   * @param {NotyService}    private notyService    Notifications service for web UI
   * @param {Router}         private router         Angular router to navigate URLs
   */
  constructor(private contactService: ContactService, private notyService: NotyService, private router: Router) {
    this.contactService.searchOptions().then((response_json) => {
      if (response_json) {
        this.searchOptions = response_json;
        this.searchParams.per_page = this.searchOptions.per_page || 20;
      } else throw 'Error fetching search options in contacts index';
    });
  }

  // Component lifecycle methods

  /**
   * Called on component initialization
   */
  ngOnInit() {
    console.log('contacts index component');
  }

  /**
   * Called after HTML is initialized
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 5000);
  }

  // Component methods

  /**
   * Add matter type to search selection
   * @param {any} newMatterType Matter type to add to selection
   */
  addMatterTypeToSearch(newMatterType: any) {
    this.selectedMatterType = null;
    for (let matterType of this.searchParams.matter_types) if (matterType.value == newMatterType.value) return;
    this.searchParams.matter_types.push(newMatterType);
    this.searchParams.matter_type_id.push(newMatterType.value);
  }

  /**
   * Add matter user type to search selection
   * @param {any} newMatterUserType Matter user type to add to selection
   */
  addMatterUserTypeToSearch(newMatterUserType: any) {
    this.selectedMatterUserType = null;
    for (let matterUserType of this.searchParams.matter_user_types) if (matterUserType.value == newMatterUserType.value) return;
    this.searchParams.matter_user_types.push(newMatterUserType);
    this.searchParams.matter_user_type_ids.push(newMatterUserType.value);
  }

  /**
   * Add role type to search selection
   * @param {any} newRoleType Role type to add to selection
   */
  addRoleTypeToSearch(newRoleType: any) {
    console.log("role types", this.searchOptions.role_types);
    this.selectedRoleType = null;
    for (let roleType of this.searchParams.role_types) if (roleType.value == newRoleType.value) return;
    this.searchParams.role_types.push(newRoleType);
    this.searchParams.role_type_ids.push(newRoleType.value);
  }

  /**
   * Process bulk edit
   */
  bulkEdit() {
    this.bulkEditParams.page = this.searchParams.page;
    this.bulkEditParams.per_page = this.searchParams.per_page;
    if (this.bulkEditParams.contacts_bulk_edit_selection == 'user_select') {
      let selectedContactIds: Array<number> = [];
      for (let contact of this.contacts) if (contact.selected) selectedContactIds.push(contact.id);
      if (selectedContactIds.length < 1) {
        this.notyService.notify('Atleast one contact must be selected for custom selection', 'error');
      } else this.bulkEditParams.contacts_bulk_edit_selected = selectedContactIds.join(',');
    } else this.bulkEditParams.contacts_bulk_edit_selected = undefined;
    this.submittingBulkEdit = true;
    this.contactService
      .index(this.bulkEditParams)
      .then((response_json) => {
        this.submittingBulkEdit = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Bulk Edit successful', 'success');
          this.showBulkEdit = false;
        } else this.notyService.notify(response_json.text || 'Bulk Edit failed', 'error');
      })
      .catch(() => {
        this.submittingBulkEdit = false;
        this.notyService.notify('Bulk Edit failed', 'error');
      });
  }

  /**
   * Clear search
   */
  clearSearch() {
    this.searchParams = {
      matter_type_id: [],
      matter_types: [],
      page: 1,
      per_page: this.searchOptions.per_page || 20,
      role_type_ids: [],
      role_types: [],
      search: true,
    };
  }

  /**
   * Deselect all contacts
   */
  deselectAll() {
    this.bulkEditParams.contacts_bulk_edit_selection = 'user_select';
    for (let contact of this.contacts) contact.selected = false;
  }

  /**
   * Page changed
   * @param {any} $event Page change event with new page number
   */
  pageChanged($event: any) {
    this.searchParams.page = $event.page;
    this.search();
  }

  /**
   * Remove matter user type from search
   * @param {any} matterUserTypeToRemove Matter user type to remove
   */
  removeMatterUserTypeFromSearch(matterUserTypeToRemove: any) {
    let matterUserTypeIndex: any;
    for (let index in this.searchParams.matter_user_types)
      if (this.searchParams.matter_user_types[index].value == matterUserTypeToRemove.value) {
        matterUserTypeIndex = index;
        break;
      }
    if (matterUserTypeIndex > -1) {
      this.searchParams.matter_user_types.splice(matterUserTypeIndex, 1);
      this.searchParams.matter_user_type_ids.splice(matterUserTypeIndex, 1);
    }
  }

  /**
   * Remove matter type from search
   * @param {any} matterTypeToRemove Matter type to remove
   */
  removeMatterTypeFromSearch(matterTypeToRemove: any) {
    let matterTypeIndex: any;
    for (let index in this.searchParams.matter_types)
      if (this.searchParams.matter_types[index].value == matterTypeToRemove.value) {
        matterTypeIndex = index;
        break;
      }
    if (matterTypeIndex > -1) {
      this.searchParams.matter_types.splice(matterTypeIndex, 1);
      this.searchParams.matter_type_id.splice(matterTypeIndex, 1);
    }
  }

  /**
   * Remove role type from search
   * @param {any} roleTypeToRemove Role type to remove
   */
  removeRoleTypeFromSearch(roleTypeToRemove: any) {
    let roleTypeIndex: any;
    for (let index in this.searchParams.role_types)
      if (this.searchParams.role_types[index].value == roleTypeToRemove.value) {
        roleTypeIndex = index;
        break;
      }
    if (roleTypeIndex > -1) {
      this.searchParams.role_types.splice(roleTypeIndex, 1);
      this.searchParams.role_type_ids.splice(roleTypeIndex, 1);
    }
  }

  /**
   * Process search request
   */
  search() {
    this.searching = true;
    this.contactService
      .index(this.searchParams)
      .then((response_json) => {
        this.searching = false;
        if (response_json.success) {
          this.contacts = response_json.contacts;
          this.count = response_json.contacts_size;
          if (this.count == 1 && this.contacts.length == 1) {
            this.router.navigateByUrl(`/contacts/${this.contacts[0].id}`);
            return;
          }
          if (this.count > 0 && !this.bulkEditOptionsLoaded) this.contactService.bulkEditOptions().then((response_json) => (this.bulkEditOptions = response_json));
          this.sidebarOpen = false;
        } else {
          this.contacts = [];
          this.count = 0;
          this.notyService.notify(response_json.text || 'Error getting contact search results', 'error', 5000, 'topRight');
        }
      })
      .catch(() => {
        this.searching = false;
        this.notyService.notify('Error getting contact search results', 'error', 5000, 'topRight');
      });
  }

  // Positioning events and methods
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
    }
  }
}
